import api from './api';

const fetchSummary = () => api.get('/api/dashboard-summary/');

export default { fetchSummary };
